import React, {Component} from 'react'
import PropTypes from "prop-types";
import utils from "../../utils/utils";
import Constants from "../../utils/constants";
import PatientSelectComponent from "../single_components/PatientSelectComponent";
import Error from "../single_components/Error";
import FormElementContainer from "../forms_builder/FormElementContainer";
import SvGraphics from "../../assets/SvGraphics";
import Select from "react-select";
import DatePicker from "react-datepicker";

class VisitSummaryFirstBlock extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
            nextVisitDoc: this.props.nextVisitDoc
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }

    componentDidMount() {
    }

    render() {
        let {t} = this.props
        let {entry, nextVisitDoc} = this.state
        let perc_date = ""
        if (entry.Validity_of_prescription) {
            perc_date = new Date(entry.Validity_of_prescription)
        }

        let nextVisitDocOptions = [nextVisitDoc.length]
        for (let i = 0; i < nextVisitDoc.length; i++) {
            nextVisitDocOptions[i] = {value: nextVisitDoc[i].index, label: nextVisitDoc[i].FromDoctor}
        }


        return (
            <div className={'patientsFormBoxes-visitSummary'}>
                <div className={'patientsFormRow'}>
                    <div className={'inputSlots'}>
                        <div className='flex-Display'>
                            <label className={'infoLabel'}>{t('patient_boarding.Type_of_visit')}</label>
                        </div>
                        <select className={'selectBox'} id="Type_of_visit" name="Type_of_visit"
                                value={entry.Type_of_visit}
                                onChange={(event) => this.props.onValueChange("Type_of_visit", event.target.value)}>
                            <option/>
                            <option value="Normal">{t('patient_boarding.normal')}</option>
                            <option value="Talmedsen">{t('patient_boarding.talmedsen')}</option>
                        </select>
                    </div>
                    <div className={'inputSlots'} style={{display: "flex", marginTop: '24px'}}>
                        <input type={"checkbox"} className={"checkboxStyle-visitSummary"} name={"cannabis_patient"}
                               checked={entry.cannabis_patient}
                               onChange={event => this.props.onClickCheckboxes(event.target.name)}/>
                        <div className={'infoLabel-cannabisPatient'}>{t('patient_boarding.cannabis_patient')}</div>

                    </div>

                    <div className={'inputSlots'}>
                        <div className={'infoLabel'}>{t('patient_boarding.prescription_validity')}:</div>
                        <DatePicker
                            className={'inputBoxStyle-medium'}
                            showYearDropdown={true} showMonthDropdown={true}
                            dateFormat="dd/MM/yyyy"
                            selected={perc_date}
                            minDate={new Date()}
                            onChange={(event) => this.props.onValueChange("Validity_of_prescription", event)}/>
                    </div>
                </div>


                <div className={'patientsFormRow'}>

                    <div className={'inputSlotsHalfBlock-icd'}>
                        <div>
                            <label className={'infoLabel'}
                                   style={{width: '100%'}}>{t('patient_boarding.Instructions')}</label>
                            <label className={'infoLabel'} style={{
                                color: '#1d1d1b',
                                fontWeight: '300'
                            }}>{t('patient_boarding.follow_up_letter')}</label>
                        </div>
                        <PatientSelectComponent
                            options={nextVisitDocOptions}
                            selectWidth={'1644px'}
                            className={'multipleSelectBox'}
                            isMulti={true}
                            value={this.props.nextVisitDocSelected}
                            onChange={this.props.onChangeNextVisitDocChange.bind(this)}
                            placeholder=""/>
                    </div>


                </div>


                <div className={'patientsFormRow-visitSummary'}>
                    <div className={'inputSlotsDoc-full'}>
                        <div className={'infoLabel'}>{t('patient_boarding.Other_Instructions')}</div>
                       <textarea  className={'info-inputBoxStyle2'} defaultValue={entry.Other_Instructions}
                                   maxLength={5000}
                                   onChange={(event) => this.props.onValueChange("Other_Instructions", event.target.value)}/>

                    </div>

                </div>


                {entry.cannabis_patient && <div className={'patientsFormRow-visitSummary'}>
                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_boarding.cannabis_agreed')}?</label>
                        <select className={'selectBox'} id="cannabis_agreed" name="cannabis_agreed"
                                value={entry.cannabis_agreed}
                                onChange={(event) => this.props.onValueChange("cannabis_agreed", event.target.value)}>
                            <option/>
                            <option value="No">{t('patient_boarding.no')}</option>
                            <option value="Yes">{t('patient_boarding.yes')}</option>
                        </select>
                    </div>
                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_boarding.research_agreed')}?</label>
                        <select className={'selectBox'} id="research_agreed" name="research_agreed"
                                value={entry.research_agreed}
                                onChange={(event) => this.props.onValueChange("research_agreed", event.target.value)}>
                            <option/>
                            <option value="No">{t('patient_boarding.no')}</option>
                            <option value="Yes">{t('patient_boarding.yes')}</option>
                        </select>
                    </div>
                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_boarding.referred_asaya')}?</label>
                        <select className={'selectBox'} id="referred_asaya" name="referred_asaya"
                                value={entry.referred_asaya}
                                onChange={(event) => this.props.onValueChange("referred_asaya", event.target.value)}>
                            <option/>
                            <option value="No">{t('patient_boarding.no')}</option>
                            <option value="Yes">{t('patient_boarding.yes')}</option>
                        </select>
                    </div>

                </div>}
            </div>

        )
    }
}

VisitSummaryFirstBlock.propTypes = {
    onValueChange: PropTypes.func.isRequired,
    onClickCheckboxes: PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    checkboxes: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default VisitSummaryFirstBlock;
